
const VideoPlayButton = {

	/**
	 *
	 * @param {HTMLElement} element
	 */
	init: function (element) {

		const video = element.querySelector('video');
		const button = element.querySelector('button');

		if (!video || !button) {
			return;
		}

		button.addEventListener('click', function () {
			video.setAttribute('controls', '');
			video.play();
		});

		video.addEventListener('play', function () {
			element.classList.add('is-playing');
			element.classList.add('has-played');
		});

		video.addEventListener('pause', function () {
			element.classList.remove('is-playing');
		});

	},

};

export default VideoPlayButton;
